import * as React from 'react';

// Citizens Information brand assets
import citizensLogoFull from './logo-full.png';
import citizensLogoWhite from './logo-white.png';
import citizensIrishLogoWhite from './irish-logo-white.png';
import citizensLogoIcon from './logo-icon.png';

export const Logo: React.FC<{
  width?: number;
  variant?: 'full' | 'white';
  language?: 'en' | 'ga';
}> = ({ width, variant='full', language='en' }) => {
  let src: string;
  switch (variant) {
    case 'white':
      src = language === 'ga' ? citizensIrishLogoWhite : citizensLogoWhite;
      break;
    case 'full':
      src = citizensLogoFull;
      break;
    default:
      src = citizensLogoFull;
      break;
  }
  const bg = variant === 'full' ? 'var(--logo-bg-full)' : 'var(--logo-bg-transparent)';
  return (
    <span style={{ 
      display: 'var(--logo-display)', 
      background: bg, 
      padding: 'var(--logo-padding)' 
    }}>
      <img src={src} width={width} height="auto" alt="Citizens Information" />
    </span>
  );
};

export const Icon: React.FC<{ 
  width?: number; 
  height?: number; 
  className?: string;
  /** Set to true for decorative avatars (adds alt="" for screen readers) */
  decorative?: boolean;
}> = ({ 
  width=20, 
  height=20, 
  className,
  decorative=false
}) => {
  return (
    <img 
      src={citizensLogoIcon} 
      alt={decorative ? "" : "Citizens Information"}
      aria-hidden={decorative ? "true" : undefined}
      width={width}
      height={height}
      className={className}
      style={{ 
        borderRadius: 'var(--logo-icon-radius)', 
        objectFit: 'var(--logo-icon-object-fit)' as React.CSSProperties['objectFit']
      }}
    />
  );
};
